/* snr-bundle-guard (audit 21 Oct 2026): keeps add-on lines tied to their set.
   Add-on lines carry properties._addon = '1' and the set's properties._bundle id (set by snr-guided.js).
   If the set line is removed, its add-ons are removed too, so nobody pays for an "Extra-bright star" with no star. */
(function () {
  'use strict';
  var R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/', busy = false;
  function check() {
    if (busy) return; busy = true;
    fetch(R + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var items = c.items || [], parents = {}, upd = {}, n = 0;
      items.forEach(function (i) { var p = i.properties || {}; if (p._bundle && p._addon !== '1') parents[p._bundle] = 1; });
      items.forEach(function (i) { var p = i.properties || {}; if (p._addon === '1' && p._bundle && !parents[p._bundle] && p.For !== 'Whole order') { upd[i.key] = 0; n++; } });
      if (!n) return;
      return fetch(R + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: upd }) })
        .then(function () { location.reload(); });
    }).catch(function () {}).then(function () { busy = false; });
  }
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(check, 300); });
  if (/\/cart\/?$/.test(location.pathname)) check();

  /* Item 18 (optional, Rhys to decide): forget the saved star name once an order has gone through.
     snr-guided.js sets snr_added=1 on add to bag. After checkout Shopify empties the cart, so on the next storefront visit
     an empty cart + snr_added=1 means "ordered" (or the bag was emptied by hand): clear the saved names. */
  try {
    if (localStorage.getItem('snr_added') === '1') fetch(R + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      if (c && c.item_count === 0) ['snr_added', 'snr_name', 'snr_name2'].forEach(function (k) { localStorage.removeItem(k); });
    }).catch(function () {});
  } catch (e) {}
})();